import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const eur = (n) => `€ ${Number(n || 0).toFixed(2).replace(".", ",")}`;

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const STATUS_META = {
  nieuw: { label: "Nieuw", color: "#F59E0B", bg: "rgba(245,158,11,0.15)" },
  in_behandeling: { label: "In behandeling", color: "#0EA5E9", bg: "rgba(14,165,233,0.15)" },
  voltooid: { label: "Voltooid", color: "#10B981", bg: "rgba(16,185,129,0.15)" },
};
